import AmeIcon from '@/components/AmeIcon/AmeIcon'
import StaffQr from '@/components/StaffQr/StaffQr'
import { UserInfoPopover } from '@/components/UserInfoPopover/UserInfoPopover'
import { toastController } from '@/controllers/toastController'
import { uiController } from '@/controllers/uiController'
import { commonUtils } from '@/helpers/commonUtils'
import { userService } from '@/services/userService'
import { Divider, Popover } from 'antd'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import style from './Dashboard.module.less'

export const Dashboard = observer(() => {
  const location = useLocation()
  const isChat = location.pathname === '/dashboard/chat'
  const isGlossary = location.pathname === '/dashboard/glossary'
  const isTranslate =
    location.pathname === '/dashboard/translate' || location.pathname === '/dashboard'
  const isHelpCenter = location.pathname === '/dashboard/help_center'

  return (
    <div className={classNames(style.dashboard)}>
      <div className={classNames(style.mainNav)}>
        <div className={classNames(style.header)}>
          <img className={style.logo} src={commonUtils.getStaticFile('icon__logo.png')} />

          {userService.isLogin && (
            <UserInfoPopover
              trigger='hover'
              displayType='popover'
              placement='bottomRight'
              getPopupContainer={(el) => el.parentElement!}
            >
              <div className={style.avatar}>
                <img
                  className={style.userAvatar}
                  src={userService.userData!.wxAvatar || commonUtils.getDefaultAvatar()}
                />
                <img className={style.rect} src={commonUtils.getStaticFile('pdf/rect.png')} />
              </div>
            </UserInfoPopover>
          )}
        </div>

        <div className={classNames(style.navWrap)}>
          <Link
            to='/dashboard/translate'
            className={classNames(style.navItem, { [style.active]: isTranslate })}
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用在线翻译功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <AmeIcon
              type={isTranslate ? 'icon-line-global_TranslateClick1' : 'icon-line-global_Translate'}
              className={style.icon}
            />
            <div className={classNames(style.name)}>在线翻译</div>
          </Link>
          <Link
            to='/pdf_pro'
            className={classNames(style.navItem)}
            target='__blank'
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用 PDF 翻译功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <img
              src={commonUtils.getStaticFile('icon__pdf.png')}
              alt='PDF 翻译'
              className={style.icon}
            />
            <div className={classNames(style.name)}>PDF 翻译</div>
          </Link>
          <Link
            to='/word'
            className={classNames(style.navItem)}
            target='__blank'
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用 Word翻译功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <img
              src={commonUtils.getStaticFile('icon__word.png')}
              alt='Word 翻译'
              className={style.icon}
            />
            <div className={classNames(style.name)}>Word 翻译</div>
          </Link>
          <Link
            to='/webapp/pdf?tab=img'
            className={classNames(style.navItem)}
            target='__blank'
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用图片翻译功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <img
              src={commonUtils.getStaticFile('icon__img.png')}
              alt='图片翻译'
              className={style.icon}
            />
            <div className={classNames(style.name)}>图片翻译</div>
          </Link>
          <Divider
            style={{
              margin: '2px 0',
            }}
          ></Divider>
          <Link
            to='/dashboard/glossary'
            className={classNames(style.navItem, { [style.active]: isGlossary })}
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用术语表功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <img
              src={
                isGlossary
                  ? commonUtils.getStaticFile('glossary_active.png')
                  : commonUtils.getStaticFile('glossary_default.png')
              }
              style={{
                width: '18px',
                height: '18px',
              }}
              className={style.icon}
            />
            <div className={classNames(style.name)}>术语表</div>
          </Link>
          <Link
            to='/learning'
            className={classNames(style.navItem)}
            target='__blank'
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用生词本功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <img
              src={commonUtils.getStaticFile('learn_mode_default.png')}
              style={{
                width: '18px',
                height: '18px',
              }}
              className={style.icon}
            />
            <div className={classNames(style.name)}>生词本</div>
          </Link>
          <Divider
            style={{
              margin: '2px 0',
            }}
          ></Divider>
          <Link
            to='/dashboard/chat'
            className={classNames(style.navItem, { [style.active]: isChat })}
            onClick={(e) => {
              if (!userService.isLogin) {
                e.preventDefault()
                toastController.warning('请登录后使用 AI 聊天功能')
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }
            }}
          >
            <AmeIcon
              type={isChat ? 'icon-line-global_ChatClick' : 'icon-line-global_Chat'}
              className={style.icon}
            />
            <div className={classNames(style.name)}>AI 聊天</div>
          </Link>
          <Divider
            style={{
              margin: '2px 0',
            }}
          ></Divider>
          <Link to='/pricing' className={classNames(style.navItem)} target='__blank'>
            <img
              src={commonUtils.getStaticFile('icon__vip.png')}
              alt='定价'
              className={style.icon}
            />
            <div className={classNames(style.name)}>定价</div>
          </Link>
          <Link to='/invite' className={classNames(style.navItem)} target='__blank'>
            <img
              src={commonUtils.getStaticFile('icon__invite.png')}
              alt='邀请有礼'
              className={style.icon}
            />
            <div className={classNames(style.name)}>邀请有礼</div>
          </Link>
          <Divider
            style={{
              margin: '2px 0',
            }}
          ></Divider>
          <Popover
            overlayInnerStyle={{
              padding: 0,
              boxShadow: 'unset',
              border: 'unset',
              background: 'unset',
              backgroundClip: 'unset',
            }}
            content={<StaffQr />}
            placement='right'
            trigger='click'
            showArrow={false}
            arrow={false}
            getPopupContainer={(el) => el.parentElement?.parentElement!}
            className={classNames(style.navItem)}
          >
            <AmeIcon type={'icon-line-global_CustomerService'} className={style.icon} />
            <div className={classNames(style.name)}>客服</div>
          </Popover>
          <Link
            to='/dashboard/help_center'
            className={classNames(style.navItem, { [style.active]: isHelpCenter })}
          >
            <AmeIcon
              type={isHelpCenter ? 'icon-bangzhuzhongxin2' : 'icon-bangzhuzhongxin'}
              className={style.icon}
            />
            <div className={classNames(style.name)}>帮助中心</div>
          </Link>
        </div>

        <div className={classNames(style.footer)}>
          {userService.initialed && !userService.isLogin && (
            <div
              className={classNames(style.loginBtn)}
              onClick={() => {
                uiController.loginModalProps = { open: true, showLeftBanner: false }
              }}
            >
              立即登录
            </div>
          )}
        </div>
      </div>
      <div className={classNames(style.mainContent)}>
        <Outlet />
      </div>
    </div>
  )
})
